export const DATE_FORMAT = 'DD/MM/YYYY';
export const TIME_FORMAT = 'HH:mm:ss';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

export const DATE_FORMAT_API = 'DD-MM-YYYY';
export const DATE_TIME_FORMAT_API = `${DATE_FORMAT_API} ${TIME_FORMAT}`;
export const DATE_MONTH_YEAR = 'MM/YYYY';
